var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useMemo } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import { useNavigate } from "react-router";
import { useAppDispatch, useQuery, useAppSelector } from "../../hooks";
import * as api from "../../api/matches";
import { setMatchState, selectMatchState } from "../../store/match";
import { selectMatchEndCase } from "../../api";
import { useAsyncExecAction } from "../../hooks/useAsyncExecAction";
import { Delimiter } from "../../components/atoms/Delimiter";
import { getMafiaErrors, getAvailableWinCases } from "../../utils";
import { colors } from "../../styles/colors";
export function MatchEnd() {
    const { param: matchId } = useQuery("matchId");
    const dispatch = useAppDispatch();
    const { execAsyncAction } = useAsyncExecAction();
    const matchState = useAppSelector(selectMatchState);
    const nav = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    // Calculate available win cases based on alive players
    const availableWinCases = useMemo(() => {
        if (!(matchState === null || matchState === void 0 ? void 0 : matchState.players))
            return ["DRAW"];
        return getAvailableWinCases(matchState.players);
    }, [matchState === null || matchState === void 0 ? void 0 : matchState.players]);
    // Set initial win case to the first available option
    const [winCase, setWinCase] = useState(availableWinCases[0] || "DRAW");
    // console.log('MatchEnd matchState', matchState)
    const matchStateAction = () => __awaiter(this, void 0, void 0, function* () {
        const result = yield api.getMatchState(matchId || "");
        // console.log('Match getMatchState', result)
        dispatch(setMatchState(result));
        // dividePlayers(result.players)
    });
    const getMatchState = () => __awaiter(this, void 0, void 0, function* () {
        if (!matchId)
            return;
        execAsyncAction({ action: matchStateAction });
    });
    useEffect(() => {
        getMatchState();
    }, [matchId]);
    // Update winCase when available options change
    useEffect(() => {
        if (availableWinCases.length > 0 && !availableWinCases.includes(winCase)) {
            setWinCase(availableWinCases[0]);
        }
    }, [availableWinCases]);
    const getSelectMatchEndCaseAction = () => function () {
        return __awaiter(this, void 0, void 0, function* () {
            setIsSubmitting(true);
            setErrorMessage(""); // Clear any previous errors
            const result = yield selectMatchEndCase(matchId || "", winCase);
            // Update Redux store with new match state (gameStatus will be FINAL_RESULT)
            dispatch(setMatchState(result));
        });
    };
    const onClick = () => __awaiter(this, void 0, void 0, function* () {
        const success = yield execAsyncAction({
            action: getSelectMatchEndCaseAction(),
            errorHandler: (err) => __awaiter(this, void 0, void 0, function* () {
                // Extract error message from the error
                const errors = getMafiaErrors(err);
                if (errors && errors.length > 0) {
                    setErrorMessage(errors[0].message);
                }
                else {
                    setErrorMessage("Произошла ошибка при завершении игры");
                }
            }),
            final: () => {
                // Reset isSubmitting in case of error
                setIsSubmitting(false);
            }
        });
        // Redirect to match page on success to show FinalTable
        if (success) {
            nav(`/match?matchId=${matchId}`);
        }
    });
    const winCaseToText = (winCase) => {
        switch (winCase) {
            case "MAFIA_WIN":
                return "победой Мафии";
            case "CIVILIANS_WIN":
                return "победой Мирных";
            case "ANARCHIST_WIN":
                return "победой Анархиста";
            case "WEREWOLF_WIN":
                return "победой Оборотня";
            case "DRAW":
                return "Ничьей";
            default:
                return "Unknown";
        }
    };
    const handleWinCaseChange = (newWinCase) => {
        setWinCase(newWinCase);
        setErrorMessage(""); // Clear error when user changes selection
    };
    return (_jsx(Box, Object.assign({ sx: {
            minHeight: "100vh",
            backgroundColor: colors.background,
            padding: "24px",
        } }, { children: _jsx(Box, Object.assign({ sx: { maxWidth: "600px", margin: "0 auto" } }, { children: _jsxs(Paper, Object.assign({ sx: {
                    padding: 3,
                    display: "flex",
                    flexDirection: "column",
                } }, { children: [_jsx(Typography, Object.assign({ variant: "h4" }, { children: "\u041A\u0442\u043E \u043F\u043E\u0431\u0435\u0434\u0438\u043B?" })), _jsx(Delimiter, { top: "30px" }), errorMessage && (_jsx(Alert, Object.assign({ severity: "error", sx: { marginBottom: 2 } }, { children: errorMessage }))), _jsxs(Box, Object.assign({ sx: { display: "flex", width: "100%", justifyContent: "center", flexWrap: "wrap", gap: "10px" } }, { children: [availableWinCases.includes("MAFIA_WIN") && (_jsx(Button, Object.assign({ variant: "outlined", onClick: () => handleWinCaseChange("MAFIA_WIN"), disabled: winCase === "MAFIA_WIN" || isSubmitting }, { children: "\u041C\u0430\u0444\u0438\u044F" }))), availableWinCases.includes("CIVILIANS_WIN") && (_jsx(Button, Object.assign({ variant: "outlined", onClick: () => handleWinCaseChange("CIVILIANS_WIN"), disabled: winCase === "CIVILIANS_WIN" || isSubmitting }, { children: "\u041C\u0438\u0440\u043D\u044B\u0435" }))), availableWinCases.includes("ANARCHIST_WIN") && (_jsx(Button, Object.assign({ variant: "outlined", onClick: () => handleWinCaseChange("ANARCHIST_WIN"), disabled: winCase === "ANARCHIST_WIN" || isSubmitting }, { children: "\u0410\u043D\u0430\u0440\u0445\u0438\u0441\u0442" }))), availableWinCases.includes("WEREWOLF_WIN") && (_jsx(Button, Object.assign({ variant: "outlined", onClick: () => handleWinCaseChange("WEREWOLF_WIN"), disabled: winCase === "WEREWOLF_WIN" || isSubmitting }, { children: "\u041E\u0431\u043E\u0440\u043E\u0442\u0435\u043D\u044C" }))), availableWinCases.includes("DRAW") && (_jsx(Button, Object.assign({ variant: "outlined", onClick: () => handleWinCaseChange("DRAW"), disabled: winCase === "DRAW" || isSubmitting }, { children: "\u041D\u0438\u0447\u044C\u044F" })))] })), _jsx(Delimiter, { top: "24px" }), _jsxs(Button, Object.assign({ variant: "contained", onClick: () => onClick(), sx: { alignSelf: "center" }, disabled: isSubmitting }, { children: ["\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0438\u0433\u0440\u0443 ", winCaseToText(winCase)] }))] })) })) })));
}
